import axios from 'axios';
import http_configs from '../configs/http_config.json';


//CREATION OF HTTP REQUEST via (AXIOS)
class httpRequest{
	constructor(url = '', method = 'GET', data_params = null, custom_headers = null){
		this.url = url;
		this.method = method; //could be POST, GET , PUT , UPDATE (or any types of HTTP Methods based on the web docs)
		this.params = data_params;
		this.additional_headers = custom_headers;
		this.axiosRequest = null;
		this.http_config = http_configs;
		//REACT_APP_API_BASE_URL (set at build time) wins over the local config
		this.api_base_url = process.env.REACT_APP_API_BASE_URL || http_configs.api_base_url;
	}//end fn

	send(callback, onError = null){
		switch(this.method.toUpperCase()){
			case 'POST':
				this.__sendPost(callback, onError);
			break;

			default:
				this.__sendGet(callback, onError);
			break;
		}//end case
	}//end fn

	__headers(){
		return Object.assign({ "app_key": this.http_config.app_key }, this.additional_headers || {});
	}//end fn

	__sendPost(callback, onError){
		let headers = {
			"headers": this.__headers()
		};

		axios.post(this.api_base_url+this.url, this.params, headers)
		.then(function (response) {
			callback(response.data);
		})
		.catch(function (error) {
			console.log(error);
			if(onError) onError(error);
			return false;
		})
		.then(function () {
	    // always executed
	    console.log('Request Finished (P101)');
	  });;
	}//end fn

	__sendGet(callback, onError){
		if(this.params == null){
			var params = {};
		}else{
			var params = {params: this.params}
		}//end if
		params.headers = this.__headers();

		axios.get(this.api_base_url+this.url, params)
	  .then(function (response) {
	    // handle success
	    callback(response.data);
	  })
	  .catch(function (error) {
	    // handle error
	    console.log(error);
	    if(onError) onError(error);
	  })
	  .then(function () {
	    // always executed
	    console.log('Request Finished (G101)');
	  });
	}//end fn
}//end fn

export { httpRequest };